'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the error div.
 * @extends {Component}
 */
var MshErrorDivComponent = function (_React$Component) {
  _inherits(MshErrorDivComponent, _React$Component);

  function MshErrorDivComponent() {
    _classCallCheck(this, MshErrorDivComponent);

    return _possibleConstructorReturn(this, (MshErrorDivComponent.__proto__ || Object.getPrototypeOf(MshErrorDivComponent)).apply(this, arguments));
  }

  _createClass(MshErrorDivComponent, [{
    key: 'displayErrors',
    value: function displayErrors(errors) {
      if (errors.length > 0) {
        var errorSet = new Set();

        errors.forEach(function (error) {
          errorSet.add(error.message);
        });

        return _react2.default.createElement(
          'div',
          { className: 'alert alert-danger', role: 'alert' },
          _react2.default.createElement(
            'p',
            { className: 'bg-danger' },
            (0, _translate.t)(_config2.default.messages.error_message),
            ':'
          ),
          [].concat(_toConsumableArray(errorSet)).map(function (error, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              error
            );
          })
        );
      }
      return undefined;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'errors-container' },
        this.props.errors ? this.displayErrors(this.props.errors) : null
      );
    }
  }]);

  return MshErrorDivComponent;
}(_react2.default.Component);

MshErrorDivComponent.propTypes = {
  errors: _react2.default.PropTypes.array
};
exports.default = MshErrorDivComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/MshErrorDivComponent.jsx
// module id = 403
// module chunks = 0